import GetAppSystemWebApiByIdRequestModelBase from '../_generated/modelBases/get-app-system-web-api-by-id-request-model-base';

export default class GetAppSystemWebApiByIdRequestModel extends GetAppSystemWebApiByIdRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
